// Minimal Dawn-like cart utilities for Concocina theme
if (!window.themeCartUtils) {
  (function () {
    const routes = window.routes || {
      cart_add_url: '/cart/add.js',
      cart_change_url: '/cart/change.js',
      cart_update_url: '/cart/update.js'
    };

    function fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: {
          'Accept': type === 'json' ? 'application/json' : '*/*',
          'Content-Type': 'application/json'
        }
      };
    }

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }

    function trapFocus(container, initialFocus) {
      const focusableSelectors =
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
      const focusableElements = Array.from(
        container.querySelectorAll(focusableSelectors)
      ).filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));

      if (!focusableElements.length) return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (initialFocus && focusableElements.includes(initialFocus)) {
        initialFocus.focus();
      } else {
        first.focus();
      }

      function handleKeydown(event) {
        if (event.key !== 'Tab') return;

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      container.__trapFocusHandler = handleKeydown;
      container.addEventListener('keydown', handleKeydown);
    }

    function removeTrapFocus(container) {
      if (container && container.__trapFocusHandler) {
        container.removeEventListener('keydown', container.__trapFocusHandler);
        delete container.__trapFocusHandler;
      }
    }

    window.themeCartUtils = {
      routes,
      fetchConfig,
      debounce,
      trapFocus,
      removeTrapFocus
    };
  })();
}

